import { render, staticRenderFns } from "./EditAdmin.vue?vue&type=template&id=cbb86c4c"
import script from "./EditAdmin.vue?vue&type=script&lang=js"
export * from "./EditAdmin.vue?vue&type=script&lang=js"
import style0 from "./EditAdmin.vue?vue&type=style&index=0&id=cbb86c4c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports